<template>
  <div></div>
</template>

<script>
  import {mapGetters} from "vuex";

  export default {
    name: "Activated",
    props: [
      'uid',
      'token'
    ],
    computed: {
      ...mapGetters("auth", ['user', 'is_authenticated']),
    },
    mounted() {
      const payload = {
        uid: this.$props.uid,
        token: this.$props.token,
      }
      if (this.user.is_email_activated === false) {
        this.$store.dispatch("auth/registration_activation", payload).then(() => {
          this.$router.push({name: 'profile_personal'})
        })
      } else {
        this.$router.push({name: 'login'})
      }
    }
  }
</script>
